import React,{ useContext, useState } from 'react';
import cn from 'classnames';
import styles from './ProfileEdit.module.sass';
import TextInput from '../../components/TextInput';
import TextArea from '../../components/TextArea';
import EmailSection from './EmailSection';
import PasswordSection from './PasswordSection';
import UserPhoto from '../../components/UserPhoto';
import { UserContext } from '../../contexts/UserContext';
import { ConquerContext } from '../../contexts/ConquerContext';
import Loader from '../../components/LoaderCircle';

const ProfileEdit = () => {

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );

    const userData = userContext && userContext.userData ? userContext.userData : {};
    const [firstName, setFirstname] = useState( userData.firstName || '' );
    const [lastName, setLastname] = useState( userData.lastName || '' );
    const [bio, setBio] = useState( userData.bio || '' );

    const [isLoading, setIsLoading] = useState( false );

    function doLogout() {

        if( !userData.isLogged ) return;
        conquer.Auth.logout();
        userContext.refresh();

    }

    async function updateProfile(){

        if( !userData.isLogged ) return;

        setIsLoading( true );
        let response = await conquer.Avatars.ME.change( { bio, firstName, lastName } );
        setIsLoading( false );

    }

    return (
        <div className={cn(styles.container)}>
            <div className={styles.top}>
                <h1 className={cn('h2', styles.title)}>Profile</h1>
            </div>
            {isLoading && <div className={styles.loaderContainer}><Loader/></div>}
            {!isLoading && <div className={styles.row}>
                <div className={styles.user}>
                    <div className={styles.avatar}>
                        <UserPhoto fallbackToMe={true}/>
                    </div>
                    {/* <div className={styles.details}>
                        <div className={styles.stage}>
                            Profile photo
                        </div>
                        <div className={styles.text}>
                            We recommend an image of at least
                            400x400. Gifs work too{' '}
                            <span role='img' aria-label='hooray'>
                                🙌
                            </span>
                        </div>
                        <div className={styles.file}>
                            <button
                                className={cn(
                                    'button button-small',
                                    styles.button
                                )}
                                onClick={() => {setIsPhotoModalVisible(true)}}>
                                Upload
                            </button>
                            <PhotoModal isVisible={isPhotoModalVisible} onClose={() => {setIsPhotoModalVisible(false)}}/>
                        </div>
                    </div> */}
                </div>
                <div className={styles.col}>
                    <div className={styles.list}>
                        <div className={styles.item}>
                            <div className={styles.fieldset}>
                                <TextInput
                                    className={styles.field}
                                    label='Firstname'
                                    name='firstname'
                                    type='text'
                                    placeholder='Enter your firstname'
                                    required
                                    value={firstName}
                                    onChange={(event) => { setFirstname(event.target.value) }}
                                />
                                <TextInput
                                    className={styles.field}
                                    label='Lastname'
                                    name='lastname'
                                    type='text'
                                    placeholder='Enter your lastname'
                                    required
                                    value={lastName}
                                    onChange={(event) => { setLastname(event.target.value) }}
                                />
                                <TextArea
                                    className={styles.field}
                                    label='Bio'
                                    name='Bio'
                                    placeholder='About yourself in a few words'
                                    required='required'
                                    value={bio}
                                    onChange={(event) => { setBio(event.target.value) }}
                                />
                            </div>
                            <div className={styles.btns}>
                                <button className={cn('button', styles.button)} onClick={updateProfile}>
                                    Update Profile
                                </button>
                                <PasswordSection />
                            </div>
                        </div>
                        <div className={styles.item}>
                            <div className={styles.fieldset}>
                                    <EmailSection/>
                            </div>
                        </div>
                        <div className={cn(styles.item, 'btn_container')}>
                            <button className={cn('button','secondary')} onClick={doLogout}>Logout</button>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    );
};

export default ProfileEdit;
